/* JMO delivery-date estimates for the cart (page + drawer).
   Same rules as the product page (snippets/jmo-ship-delivery.liquid, ported
   from the live theme): ships same day Mon-Fri before 3:00 PM New York time,
   then UPS Ground business days from 44060 Mentor, OH by first 3 ZIP digits.
   AK / HI / PR / territories: no date (generic free-shipping text stays).
   ZIP is shared with the product page via localStorage 'jmo_zip'.

   Markup hooks:
   - [data-jmo-cart-eta]  per cart item; filled with "FREE delivery Tue, Oct 13"
   - [data-jmo-cart-zip]  ZIP prompt/result inside the free-shipping box
   Cart sections are re-rendered by the theme after every change, so a
   MutationObserver re-applies the estimates. */
(function () {
  var CUTOFF_HOUR = 15;
  var CUTOFF_MINUTE = 0;
  var TZ = 'America/New_York';
  var DAY = 86400000;
  var ZIP_KEY = 'jmo_zip';

  function etParts(d) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(d);
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    return { wd: get('weekday'), hour: parseInt(get('hour'), 10), minute: parseInt(get('minute'), 10) };
  }

  function transitDays(zip) {
    var p = parseInt(zip.slice(0, 3), 10);
    if (isNaN(p)) return null;
    if (p <= 9) return null;                      // PR / VI
    if (p >= 995) return null;                    // AK
    if (p === 967 || p === 968) return null;      // HI
    if (p >= 430 && p <= 459) return 1;           // Ohio
    if (p >= 150 && p <= 168) return 1;           // western PA
    if (p >= 480 && p <= 485) return 1;           // SE Michigan
    if (p >= 260 && p <= 266) return 1;           // northern WV
    if (p >= 10 && p <= 149) return 2;            // New England, NJ, NY
    if (p >= 169 && p <= 299) return 2;           // rest PA, DE MD DC VA WV NC SC
    if (p >= 370 && p <= 385) return 2;           // TN
    if (p >= 400 && p <= 429) return 2;           // KY
    if (p >= 460 && p <= 479) return 2;           // IN
    if (p >= 486 && p <= 499) return 2;           // rest of MI
    if (p >= 530 && p <= 549) return 2;           // WI
    if (p >= 600 && p <= 629) return 2;           // IL
    if (p >= 300 && p <= 369) return 3;           // GA FL AL
    if (p >= 386 && p <= 399) return 3;           // MS
    if (p >= 500 && p <= 528) return 3;           // IA
    if (p >= 550 && p <= 589) return 3;           // MN ND SD
    if (p >= 590 && p <= 599) return 4;           // MT
    if (p >= 630 && p <= 699) return 3;           // MO KS NE
    if (p >= 700 && p <= 749) return 3;           // LA AR OK
    if (p >= 797 && p <= 799) return 4;           // far-west TX (El Paso)
    if (p >= 750 && p <= 796) return 3;           // TX
    if (p >= 800 && p <= 899) return 4;           // Mountain West, NM, NV
    if (p >= 900 && p <= 966) return 4;           // CA
    if (p >= 970 && p <= 994) return 5;           // OR WA
    return 3;
  }

  function nextShipDate() {
    var d = new Date();
    var now = etParts(d);
    var before = now.hour < CUTOFF_HOUR || (now.hour === CUTOFF_HOUR && now.minute < CUTOFF_MINUTE);
    var isWeekday = now.wd !== 'Sat' && now.wd !== 'Sun';
    if (!(isWeekday && before)) d = new Date(d.getTime() + DAY);
    for (var i = 0; i < 7; i++) {
      var w = etParts(d).wd;
      if (w !== 'Sat' && w !== 'Sun') break;
      d = new Date(d.getTime() + DAY);
    }
    return d;
  }

  function addBizDays(start, n) {
    var d = new Date(start);
    while (n > 0) {
      d = new Date(d.getTime() + DAY);
      var w = etParts(d).wd;
      if (w !== 'Sat' && w !== 'Sun') n--;
    }
    return d;
  }

  function etaLabel(zip) {
    var days = transitDays(zip);
    if (days === null) return null;
    try {
      return addBizDays(nextShipDate(), days).toLocaleDateString('en-US', { timeZone: TZ, weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) { return null; }
  }

  function getZip() {
    try { var z = localStorage.getItem(ZIP_KEY); return (z && /^\d{5}$/.test(z)) ? z : null; } catch (e) { return null; }
  }
  function setZip(zip) {
    try { localStorage.setItem(ZIP_KEY, zip); } catch (e) { /* private mode */ }
  }

  var applying = false;
  function apply() {
    if (applying) return;
    applying = true;
    var zip = getZip();
    var label = zip ? etaLabel(zip) : null;

    document.querySelectorAll('[data-jmo-cart-eta]').forEach(function (el) {
      var html = label
        ? 'FREE delivery <strong>' + label + '</strong>'
        : '<strong>FREE shipping</strong>';
      if (el.innerHTML !== html) el.innerHTML = html;
    });

    document.querySelectorAll('[data-jmo-cart-zip]').forEach(function (el) {
      var mode = el.getAttribute('data-mode');
      if (mode === 'editing') return; // customer is typing a new ZIP; leave the input alone
      if (zip && mode !== 'result-' + zip) {
        el.setAttribute('data-mode', 'result-' + zip);
        el.innerHTML = 'Delivering to <strong>' + zip + '</strong>' +
          '<button type="button" class="jmo-cart-zip__change" data-jmo-cart-zip-change>Change</button>';
      } else if (!zip && mode !== 'prompt') {
        el.setAttribute('data-mode', 'prompt');
        el.innerHTML = 'Delivery date: ' +
          '<input class="jmo-cart-zip__input" data-jmo-cart-zip-input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" autocomplete="postal-code" placeholder="ZIP code" aria-label="ZIP code for delivery date"> ' +
          '<button type="button" class="jmo-cart-zip__btn" data-jmo-cart-zip-go>Check</button>';
      }
    });
    applying = false;
  }

  function submitZip(box) {
    var input = box.querySelector('[data-jmo-cart-zip-input]');
    if (!input) return;
    var zip = input.value.trim();
    if (!/^\d{5}$/.test(zip)) {
      input.classList.add('jmo-cart-zip__input--invalid');
      input.focus();
      return;
    }
    setZip(zip);
    box.removeAttribute('data-mode');
    apply();
    document.dispatchEvent(new CustomEvent('jmo:zip', { detail: zip }));
  }

  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-jmo-cart-zip-go]');
    if (go) { submitZip(go.closest('[data-jmo-cart-zip]')); return; }
    var change = e.target.closest('[data-jmo-cart-zip-change]');
    if (change) {
      var box = change.closest('[data-jmo-cart-zip]');
      var prev = getZip() || '';
      box.setAttribute('data-mode', 'editing');
      box.innerHTML = 'Delivery date: ' +
        '<input class="jmo-cart-zip__input" data-jmo-cart-zip-input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" autocomplete="postal-code" placeholder="ZIP code" aria-label="ZIP code for delivery date" value="' + prev + '"> ' +
        '<button type="button" class="jmo-cart-zip__btn" data-jmo-cart-zip-go>Check</button>';
      var i = box.querySelector('input');
      if (i) i.focus();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('[data-jmo-cart-zip-input]')) {
      e.preventDefault();
      submitZip(e.target.closest('[data-jmo-cart-zip]'));
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('[data-jmo-cart-zip-input]')) e.target.classList.remove('jmo-cart-zip__input--invalid');
  });

  function start() {
    apply();
    // Re-apply after the theme re-renders cart sections (quantity changes, adds).
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { apply(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    // ZIP changed on the product page, another tab, or page restored with Back.
    document.addEventListener('jmo:zip', apply);
    window.addEventListener('storage', function (e) { if (e.key === ZIP_KEY) apply(); });
    window.addEventListener('pageshow', apply);
    // Roll dates forward when the 3 PM cutoff passes.
    setInterval(apply, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
